import titleLink from '@components/ui-components/title-link/component.js'

export default {
  components: {
    'title-link-cmp': titleLink,
  },
  data() {
    return {
      vendorOptions: {
        slidesPerView: 5,
        slidesPerColumn: 2,
        spaceBetween: 56,
        speed: 600,
        cursor: 'grab',
        navigation: {
          nextEl: '.js-vendor-next',
          prevEl: '.js-vendor-prev',
        },
        breakpoints: {
          2000: {
            spaceBetween: 40,
          },
          1600: {
            spaceBetween: 32,
            slidesPerView: 4,
          },
          1300: {
            spaceBetween: 24,
          },
          1160: {
            spaceBetween: 20,
          },
          920: {
            spaceBetween: 16,
            slidesPerView: 1,
          },
        },
      },
    }
  },
  methods: {},
}



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/builder/widget/vendors/component.js